var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCollect = function SvgIconCollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#43C6A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9325 18.4416H35.9286V16.148C35.9286 15.0195 34.99 14.0844 33.8623 14.0844H24.0266L23.5982 13.0201C23.2477 12.3076 22.5087 11.8701 21.715 11.8701H13.0662C11.3752 11.8701 10 13.2187 10 14.9089V35.0903C10 36.7812 11.3752 38.1291 13.0662 38.1291H33.5254C37.0954 38.1291 40 34.8709 40 31.6818V21.5056C40 19.8154 38.6227 18.4416 36.9325 18.4416ZM32.6719 16.2273C33.1716 16.2273 33.5714 16.6244 33.5714 17.124V18.4416H25.9145L25.0308 16.2273H32.6719ZM37.8571 24.7253V31.5259C37.8571 33.957 35.868 35.9148 33.437 35.9148H13.1615C12.5989 35.9148 12.1429 35.4901 12.1429 34.9275V15.0717C12.1429 14.5091 12.5989 14.0844 13.1615 14.0844H21.7217C21.7414 14.0844 21.7597 14.0803 21.7686 14.098L24.2101 19.9858C24.3337 20.2842 24.6241 20.4757 24.947 20.4776C27.3258 20.4917 36.8382 20.4986 36.8382 20.4986C37.4009 20.4986 37.8572 20.9526 37.8572 21.5146L37.8571 24.7253Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6569 25.6018L23.8998 22.0908L22.1819 25.6211L18.2998 26.2071L21.1264 28.9319L20.4841 32.8051L23.949 30.9589L27.4342 32.7666L26.749 28.9008L29.5452 26.1448L25.6569 25.6018Z",
    fill: "white"
  })));
};
export default SvgIconCollect;